<template>
  <b-col col="12" lg="5">
    <detailed-img img="img/art-work/detailed.jpg"></detailed-img>
  </b-col>
</template>
<script>
import DetailedImg from "../../UI/itemDetails/DetailedImg.vue";
export default {
  components: { DetailedImg },
};
</script>